import { createFileRoute } from '@tanstack/react-router'

import { useAcceptVerifyIdentityEmail } from '@/gen/publicApi'

import { Button } from '@/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card'
import Spinner from '@/components/spinner'

import { useIdentity } from '@/state/identity'

export const Route = createFileRoute('/verify-email/$verify_email_token/')({
    component: VerifyEmail,
})

function VerifyEmail() {
    const { verify_email_token } = Route.useParams()
    const { identity, fetched } = useIdentity()
    const acceptChange = useAcceptVerifyIdentityEmail(verify_email_token, {
        query: {
            retry: false,
        },
    })
    const returnHome = () => {
        // Hard refresh so that the identity is totally reloaded. If there's
        // no identity, this will end up redirecting to the login page
        window.location.href = '/'
    }

    if (acceptChange.isLoading || !fetched) {
        return <Spinner size="md" absolute />
    }

    if (acceptChange.error) {
        return (
            <Card className="absolute-center w-96">
                <CardHeader>
                    <CardTitle>Error</CardTitle>
                </CardHeader>
                <CardContent>
                    <CardDescription className="mb-4">
                        Something went wrong and we could not verify your email address
                    </CardDescription>
                    <Button className="mt-4" onClick={returnHome}>
                        Return home
                    </Button>
                </CardContent>
            </Card>
        )
    }

    return (
        <Card className="absolute-center w-96">
            <CardHeader>
                <CardTitle>Email verified</CardTitle>
            </CardHeader>
            <CardContent>
                <CardDescription className="mb-4">Your email has been updated!</CardDescription>
                <Button className="mt-4" onClick={returnHome}>
                    {identity ? 'Return home' : 'Login'}
                </Button>
            </CardContent>
        </Card>
    )
}
